/*
 * kitchen-config.js — Kitchen-closed "back at 9 AM" config (W2, B2C-186)
 *
 * Single source of truth for the kitchen window + the fresh-SKU allowlist.
 * Data + pure lookups only (no DOM, no fetch, no events). Loaded with `defer`;
 * assigns a namespaced global `window.CasinettoKitchen`. The runtime controller
 * (kitchen.js) consumes it. See decisions/kitchen-closed.md + spec-kitchen-closed.md.
 *
 * Kitchen hours are deliberately trivial to change — edit OPEN_HOUR / CLOSE_HOUR.
 * Time is computed against Dubai local (fixed UTC+4, no DST), self-contained here
 * (decisions Q2 option b — we do NOT touch delivery-engine.js for a 5-line offset).
 */
(function () {
  'use strict';

  // ---- Kitchen window (Dubai local hours; open is [OPEN_HOUR, CLOSE_HOUR)) ----
  var OPEN_HOUR = 9;   // 09:00 — reopen / kitchen opens
  var CLOSE_HOUR = 22; // 22:00 — kitchen closes

  var DUBAI_OFFSET_MIN = 4 * 60; // UTC+4, no DST

  // ---- Fresh / kitchen-made base SKUs (spec Appendix A, ~61) ----
  // Runtime variant SKUs carry a _N suffix (e.g. PASD602_1), stripped before lookup.
  var FRESH_LIST = [
    // Pastries — PASD602..PASD641
    'PASD602', 'PASD603', 'PASD604', 'PASD605', 'PASD606', 'PASD607', 'PASD608', 'PASD609',
    'PASD610', 'PASD611', 'PASD612', 'PASD613', 'PASD614', 'PASD615', 'PASD616', 'PASD617',
    'PASD618', 'PASD619', 'PASD620', 'PASD621', 'PASD622', 'PASD623', 'PASD624', 'PASD625',
    'PASD626', 'PASD627', 'PASD628', 'PASD629', 'PASD630', 'PASD631', 'PASD632', 'PASD633',
    'PASD634', 'PASD635', 'PASD636', 'PASD637', 'PASD638', 'PASD639', 'PASD640', 'PASD641',
    // Pastries — PASC
    'PASC536', 'PASC537', 'PASC538', 'PASC539', 'PASC600', 'PASC601', 'PASC602', 'PASC603',
    'PASC604', 'PASC605', 'PASC607', 'PASC608', 'PASC609', 'PASC610', 'PASC611',
    // Gelato — all six (broader than the gelato FLAVOUR allowlist of 110/111/142/520)
    'GELF110', 'GELF111', 'GELF142', 'GELF520', 'GELF531', 'GELF532'
  ];

  // Object-as-set for O(1) membership.
  var FRESH_SET = {};
  for (var i = 0; i < FRESH_LIST.length; i++) {
    FRESH_SET[FRESH_LIST[i]] = true;
  }

  function normaliseSku(sku) {
    if (!sku) {
      return '';
    }
    return String(sku).replace(/_\d+$/, '');
  }

  function isFresh(sku) {
    return FRESH_SET[normaliseSku(sku)] === true;
  }

  // (date?) -> Date shifted to Dubai local wall-clock. Pass a Date to test a fixed instant.
  function dubaiNow(date) {
    var n = date ? new Date(date) : new Date();
    var utc = n.getTime() + n.getTimezoneOffset() * 60000;
    return new Date(utc + DUBAI_OFFSET_MIN * 60000);
  }

  // Kitchen open iff Dubai-local hour is within [OPEN_HOUR, CLOSE_HOUR).
  function isOpen(date) {
    var h = dubaiNow(date).getHours();
    return h >= OPEN_HOUR && h < CLOSE_HOUR;
  }

  // 9 -> "9:00 AM", 22 -> "10:00 PM" — for copy interpolation (NOT hardcoded).
  function formatHour(hour) {
    var period = hour < 12 ? 'AM' : 'PM';
    var h12 = hour % 12;
    if (h12 === 0) {
      h12 = 12;
    }
    return h12 + ':00 ' + period;
  }

  function reopenLabel() {
    return formatHour(OPEN_HOUR);
  }

  window.CasinettoKitchen = {
    isFresh: isFresh,       // (sku) -> bool
    isOpen: isOpen,         // (date?) -> bool
    dubaiNow: dubaiNow,     // (date?) -> Date (Dubai wall-clock) — used for the boundary timer
    normaliseSku: normaliseSku,
    reopenLabel: reopenLabel, // () -> "9:00 AM"
    OPEN_HOUR: OPEN_HOUR,
    CLOSE_HOUR: CLOSE_HOUR
  };
})();
